import { ArrowRight } from "lucide-react";
import React from "react";

const ComingSoon = () => {
  return (
    <div className="main-container">
      <div className="content-wrapper text-center">
        <h1 className="pdf-modern-main-heading">Coming Soon</h1>
        <p className="pdf-modern-subheading">
          We're working hard to bring something amazing!
        </p>
        <a href="/create-account" className="cta-button">
          Create Account
          <ArrowRight size={20} />
        </a>
      </div>
    </div>
  );
};

export default ComingSoon;
